// Refer-a-friend (2026-09-29) -- see services/auth-service/app/referrals.py.
// A visit to any page with ?ref=<CODE> remembers the code for 30 days; the
// next sign-up (password, Google or GitHub) sends it so the referrer gets
// credit once the friend buys a plan.
const KEY = "rp360_ref";
const TTL_MS = 30 * 24 * 60 * 60 * 1000;

export function captureReferralFromUrl() {
  try {
    const code = new URLSearchParams(window.location.search).get("ref");
    if (code && /^[A-Za-z0-9]{4,16}$/.test(code)) {
      localStorage.setItem(KEY, JSON.stringify({ code: code.toUpperCase(), at: Date.now() }));
    }
  } catch {}
}

export function getReferralCode() {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) || "null");
    if (!raw || Date.now() - raw.at > TTL_MS) return null;
    return raw.code;
  } catch {
    return null;
  }
}

export const referralLink = (code) => `${window.location.origin}/?ref=${code}`;
